const ArticleTable = ({ children, caption, id, className }) => (
  <div className={`article-table-wrapper${className ? ` ${className}` : ''}`}>
    <div className="table-responsive">
      <table
        className="table table-bordered article-table"
        aria-describedby={id}
      >
        {/*<caption id={id} className="position-sticky article-table-caption body bold mt-1">{caption}</caption>*/}
        {children}
      </table>
    </div>
    {caption && (
      <p id={id} className="article-table-caption body bold mt-1 mb-3">{caption}</p>
    )}
  </div>
);

export default ArticleTable;
